import allStats from "./allStats"
import allStatsForGame from "./allStatsForGame";
import nameSurname from "./namesSurnames";
import uuid from 'react-native-uuid';

const playerObj = (name = nameSurname(), skills = generateRandomNumber(10, 70, 7), broom = generateRandomNumber(10, 70, 4), theAge = 18) => {
	return { name: name, skills: skills, broom: broom, hiddenSkills: generateRandomNumber(1, 99, 2), age: theAge, stats: allStats(), inGameStats: allStatsForGame(), injury: 0, nickname: '', uuid: uuid.v4() }
}

function generateRandomNumber(from, to, howMany) {
	const diferencia = to - from + 1;
	let numbers = [];
	for (let i = 0; i < howMany; i++) {
		numbers[i] = Math.floor(Math.random() * diferencia + from);
	}
	return numbers;
}

export default playerObj